import { useHeadingLevel } from "../contexts/heading-level/useHeadingLevel.ts";
import { HEADING_TAGS } from "../lib/tags.ts";

export function useHeadingTag(): (typeof HEADING_TAGS)[number] {
  const level = useHeadingLevel();

  return HEADING_TAGS[level - 1] ?? HEADING_TAGS[0];
}
